module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Calificaciones_Transportistas.353c2442.xlsx";